import { GlobalConfig } from "@common/utils";

import { createBrowserHistory, History } from "history";

const _history = createBrowserHistory({basename: GlobalConfig.baseUrl});

export const history: History = _history;
